import { useApollo } from '/@src/composable/useApi'
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { mallStatisticsDocument } from '/@src/api/mallStatisticsRepo'
import {
  setupAmountChartOption,
  setupOrderChartOption,
  setupOrderTypesChartOptions,
} from '/@src/utils/setChartOptions'

// interface payChannelStatistics {
//   amounts?:amounts
//   frequency?:frequency
// }
interface Item {
  datetime?: string | undefined | Date
  order_count?: number
  pay_channel_statistics?: object
  platform_statistics?: object
  revenue?: number
  sku_statistics?: object
}

export default function useMallStatisticsOrders() {
  const graph = useApollo()
  const { t, locale } = useI18n()
  const mallStatisticsWeekOrdersRes = ref()
  const mallStatistics30DaysOrdersRes = ref([])
  const weekRevenueRate = ref('')
  const lastWeek = ref(0)
  const thisWeek = ref(0)
  const daysRevenue = ref(0) //30天收入
  const daysOrderCount = ref(0) //30天订单总数
  const mallSaleschartOptions = ref({}) //30天商城收入图表
  const mallOrderChartOptions = ref({}) //30天商城订单图表
  const mallOrderTypeChartOptions = ref({}) //30天商城订单类型图表
  const daysAmountArray = ref([])
  const daysOrderCountArray = ref([])
  const daysOrderTypeMap = new Map<string, number>() //传入charts的数据
  const daysOrderType  = {}

  const start: Date = new Date(new Date().toLocaleDateString())
  start.setTime(start.getTime() - 3600 * 1000 * 24 * 29)
  const end: Date = new Date()
  const dayDiff: number = Math.ceil(
    (end.getTime() - start.getTime()) / (1000 * 3600 * 24)
  )
  let countDate: Date = start

  const itemObj = (datetime) => {
    return {
      datetime,
      order_count: 0,
      pay_channel_statistics: {
        amounts: {},
        frequency: {},
      },
      platform_statistics: {
        amounts: {},
        frequency: {},
      },
      revenue: 0,
      sku_statistics: {
        names: {},
        frequency: {},
        amounts: {},
      },
    }
  }
  const getMallStatisticsOrders = async (isShowTitle: boolean = true) => {
    const weekRes = await graph.query({
      query: mallStatisticsDocument,
      variables: {
        period: 'WEEK',
        pagination: {
          first: 2,
        },
      },
      errorPolicy: 'all',
    })
    const daysRes = await graph.query({
      query: mallStatisticsDocument,
      variables: {
        period: 'DAY',
        pagination: {
          first: 30,
        },
      },
      errorPolicy: 'all',
    })
    mallStatisticsWeekOrdersRes.value = weekRes.data.order_statistics.nodes
    lastWeek.value = mallStatisticsWeekOrdersRes.value[1].revenue / 100
    thisWeek.value = mallStatisticsWeekOrdersRes.value[0].revenue / 100
    weekRevenueRate.value =((thisWeek.value - lastWeek.value) / lastWeek.value * 100).toFixed(2)

    for (let i = 0; i < 30; i++) {
      const findObj = daysRes.data.order_statistics.nodes.find(
        (item) => new Date(item.datetime).getTime() === countDate.getTime()
      )
      mallStatistics30DaysOrdersRes.value.push(findObj || itemObj(countDate))
      countDate = new Date(countDate.getTime() + 3600 * 1000 * 24)
    }
    const names: {key: number | string, name: string}[] = []
    mallStatistics30DaysOrdersRes.value.forEach((item) => {
      daysRevenue.value += item.revenue
      daysAmountArray.value.push(item.revenue / 100)
      daysOrderCount.value += item.order_count
      daysOrderCountArray.value.push(item.order_count)
      //支付项目
      if(JSON.stringify(item.sku_statistics.frequency) !== '{}') {
        for (const key in item.sku_statistics.frequency) {
          if(daysOrderType.hasOwnProperty(key)) {
            daysOrderType.key = daysOrderType[key] + item.sku_statistics.frequency[key]
          } else {
            daysOrderType[key] = item.sku_statistics.frequency[key]
            names.push({
              key,
              name: item.sku_statistics.names[key]
            })
          }
        }
      }
    })
    names.forEach(x => {
      daysOrderTypeMap.set(
        x.name,
        +x.key
      )
    })
    mallSaleschartOptions.value = setupAmountChartOption(
      isShowTitle,
      t,
      locale.value,
      daysRevenue.value,
      daysAmountArray.value,
      start!!,
      dayDiff
    )
    mallOrderChartOptions.value = setupOrderChartOption(
      t,
      locale.value,
      daysOrderCount.value,
      daysOrderCountArray.value,
      start!!,
      dayDiff
    )

    mallOrderTypeChartOptions.value = setupOrderTypesChartOptions(
      daysOrderTypeMap,
      t,
      locale.value
    )
  }

  return {
    getMallStatisticsOrders,
    weekRevenueRate,
    lastWeek,
    thisWeek,
    mallSaleschartOptions,
    mallOrderChartOptions,
    mallOrderTypeChartOptions,
  }
}
